import schemas from '../fields/definedSchemas';

const fields = {
    school_name: {
        label: 'What is the name of the school?',
        name: 'school_name',
        boxtext: 'School Name',
    },
    course_name: {
        label: 'What course did you complete?',
        name: 'course_name',
        boxtext: 'Course Name',
    },
    course_number: {
        label: 'What is the course code?',
        name: 'course_number',
        boxtext: 'Course Number',
    },
    issue_date: {
        ...schemas.dateRequiredMaxToday,
        label: 'What day did you complete this course?',
        section: 'Training',
    },
    been_used_before: {
        ...schemas.boolRequired,
        label: 'Have you already submitted this certiciate in a previous application to the USCG?',
        section: 'Training',
    },
};

export default fields;
